import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const objections = [{
  question: 'No tengo tiempo para algo más',
  answer: 'No necesitas más tiempo. Necesitas entender tu energía para usar mejor el tiempo que ya tienes.'
}, {
  question: '¿De verdad funciona?',
  answer: 'Esto ya está ocurriendo en tu cuerpo. La guía solo te enseña a verlo y aprovecharlo.'
}, {
  question: 'Ya intenté muchas cosas y nada me funcionó',
  answer: 'El problema nunca fue tu disciplina. Era no conocer cómo funciona tu ciclo. Esta guía cambia eso.'
}];
export function ObjectionsSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-bg-alt py-16 md:py-24 px-4" data-id="element-57">
      <div className="max-w-4xl mx-auto" data-id="element-58">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="font-serif text-3xl md:text-4xl text-center text-text-primary mb-12" data-id="element-59">
          Tal vez estás pensando…
        </motion.h2>

        <div className="space-y-4" data-id="element-60">
          {objections.map((objection, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white/70 rounded-2xl overflow-hidden" data-id="element-61">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left hover:bg-white/50 transition-colors" data-id="element-62">
                <span className="font-medium text-lg text-text-primary pr-4" data-id="element-63">
                  {objection.question}
                </span>
                <ChevronDown className={`w-6 h-6 text-accent flex-shrink-0 transition-transform ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-64" />
              </button>
              {openIndex === index && <div className="px-6 pb-6" data-id="element-65">
                  <p className="text-text-secondary leading-relaxed" data-id="element-66">
                    {objection.answer}
                  </p>
                </div>}
            </motion.div>)}
        </div>
      </div>
    </section>;
}